module.exports = __webpack_public_path__ + "static/media/rui.0175914b.jpg";